var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSplash2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.6 54.2",
    style: {
      enableBackground: "new 0 0 52.6 54.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#009D63;}\n\t.st1{fill:#ABABAB;}\n\t.st2{fill:#004597;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,40.3H18.8c-0.6,0-1-0.4-1-1v-1.8c0-0.6,0.4-1,1-1h14.9c0.6,0,1,0.4,1,1v1.8 C34.8,39.8,34.3,40.3,33.8,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,33.6H18.8c-0.6,0-1-0.4-1-1v-1.8c0-0.6,0.4-1,1-1h14.9c0.6,0,1,0.4,1,1v1.8 C34.8,33.2,34.3,33.6,33.8,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,27.9H18.8c-0.6,0-1-0.4-1-1v-1.8c0-0.6,0.4-1,1-1h14.9c0.6,0,1,0.4,1,1v1.8 C34.8,27.5,34.3,27.9,33.8,27.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.3,10.8c2.5,0,4.4,2,4.4,4.4c0,2.3-1.8,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4C21.9,12.7,23.9,10.8,26.3,10.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.9,54.2l-10.5,0c-2.8,0-5.6,0-8.4,0c-2.4,0-4.3-1.5-4.7-3.9c-0.1-0.4-0.1-0.7-0.1-1.1 c0-8.8,0-17.6,0-26.3c0-0.1,0-0.3,0-0.3c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.5-0.1-0.9-0.5-1-1.1c-0.1-0.9-0.1-1.8,0-2.7 c0.1-0.6,0.5-1.1,1.1-1.1c0-0.3,0-0.5,0-0.7c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.6-0.1-1-0.5-1.1-1.2 C8,14.8,8,14.2,8,13.6c0-0.3,0-0.5,0-0.8c0-0.7,0-1.3,0-2c0-0.8,0.5-1.3,1.2-1.4l0-4.6C9.2,2,11.2,0,14,0l14.6,0 c3.9,0,7.8,0,11.2,0c1.3,0,2.5,0.5,3.4,1.4c0.9,0.9,1.4,2,1.4,3.2c0,0.2,0,0.4,0,0.7c0,0.2,0,0.5,0,0.7c0,0,0,36.9,0,42.4 c0,0.6,0,1.2-0.1,1.8c-0.2,2.2-2.2,4.1-4.5,4.1c-0.7,0-1.8,0-3,0L32.9,54.2z M14.1,2.7c-0.4,0-0.7,0.1-1,0.2 c-0.8,0.4-1.2,1-1.2,2c0,5.5,0,10.9,0,16.4l0,11.6c0,5.4,0,10.9,0,16.3c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,1,0.6,1.6,0.6 c3.9,0,8.4,0,12.8,0c4.4,0,8.8,0,12.7,0l0,0c0.7,0,1.3-0.2,1.7-0.6c0.4-0.4,0.6-1,0.6-1.6c0-10.6,0-21.2,0-31.8V5 c0-1.4-0.8-2.3-2.2-2.3l-11.7,0L14.1,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.3,49.8c-0.8,0-1.5-0.3-2-0.8c-0.5-0.5-0.8-1.3-0.8-2.1c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.9,1.3,2.9,2.9 c0,0.8-0.3,1.5-0.8,2C27.8,49.5,27.1,49.8,26.3,49.8L26.3,49.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,7.4c-0.3,0-0.6,0-0.9,0c-0.5,0-0.8-0.2-1.1-0.4c-0.2-0.2-0.4-0.6-0.3-0.9c0-0.8,0.6-1.3,1.4-1.3 c0.8,0,1.5,0,2.3,0c0.7,0,1.5,0,2.2,0C29.4,4.7,30,5.2,30,6c0,0.4-0.1,0.7-0.3,1c-0.3,0.3-0.6,0.4-1.1,0.4c-0.3,0-0.6,0-0.9,0 H24.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplash2);
export default __webpack_public_path__ + "static/media/icon-splash-2.cdc34270551f18f7582a5e0651a6c313.svg";
export { ForwardRef as ReactComponent };